// extracted by mini-css-extract-plugin
module.exports = {"wrap":"EditRequestContainer_wrap__3qjeL","title":"EditRequestContainer_title__2lLVd"};